(function () {
  var p;
  window.loadSwiper = function () {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (p) return p;
    p = new Promise(function (resolve, reject) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.css';
      document.head.appendChild(l);
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.js';
      s.defer = true;
      s.onload = function () { resolve(window.Swiper); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return p;
  };
})();
